<template>
  <div>
    <form-vue></form-vue>
  </div>
</template>
<script>
import FormVue from "./Update.vue";
export default {
  components: {
    FormVue
  }
};
</script>
